import React, { useState } from "react";
import { Mail, Phone, Instagram, Youtube, Facebook, MessageCircle, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";
import { AvailabilityForm } from "@/components/sections/HomeSections";
import SEO, { localBusinessSchema } from "@/components/SEO";

export default function Contact({ settings = {} }) {
  const [f, setF] = useState({ name:"", email:"", phone:"", message:"" });
  const [busy, setBusy] = useState(false);
  const s = {
    email: "Muj.emal@elitepixels.ca",
    phone: "+1 647 640 3625",
    whatsapp: "16476403625",
    instagram: "https://instagram.com/elitepixels_",
    youtube: "https://youtube.com/@elitepixels330",
    facebook: "",
    tiktok: "",
    ...settings,
  };
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/leads", { ...f, source: "contact" });
      toast.success("Message sent! We'll reply within 24 hours.");
      setF({ name:"", email:"", phone:"", message:"" });
    } catch { toast.error("Could not send. Please try again."); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="contact-page" className="pt-32">
      <SEO title="Contact" path="/contact" description="Say hello to Elite Pixels. Email muj.emal@elitepixels.ca or call +1 647 640 3625 — we read every message and reply personally." jsonLd={localBusinessSchema()} />
      <section className="section-pad pb-12 max-w-[1400px] mx-auto text-center">
        <div className="eyebrow">Contact</div>
        <h1 className="font-serif text-5xl md:text-6xl font-light mt-4 tracking-tight">Let's Begin Your <em className="text-[#D4AF37] not-italic">Story</em></h1>
        <p className="text-white/55 mt-4">We read every message and reply personally — usually within a day.</p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-16 pb-24">
        <div>
          <form onSubmit={submit} className="space-y-5" data-testid="contact-form">
            {[["name","Name *","text",true],["email","Email *","email",true],["phone","Phone","tel",false]].map(([k,l,t,r])=>(
              <input key={k} type={t} required={r} placeholder={l} value={f[k]} onChange={e=>setF({...f,[k]:e.target.value})}
                data-testid={`contact-${k}`}
                className="w-full bg-black border border-white/15 px-4 py-3.5 text-sm focus:border-[#D4AF37] outline-none transition"/>
            ))}
            <textarea required placeholder="Tell us a little about your wedding *" rows={6} value={f.message} onChange={e=>setF({...f,message:e.target.value})}
              data-testid="contact-message"
              className="w-full bg-black border border-white/15 px-4 py-3.5 text-sm focus:border-[#D4AF37] outline-none"/>
            <button type="submit" disabled={busy} className="btn-gold" data-testid="contact-submit">{busy?"Sending...":"Send Message"} <ArrowRight size={14}/></button>
          </form>
        </div>
        <div className="space-y-8">
          <div>
            <div className="eyebrow">Other Ways to Reach Us</div>
            <h2 className="font-serif text-3xl mt-2">Whichever feels easiest.</h2>
            <p className="text-white/55 mt-3 text-sm">We reply personally — often the same day during regular hours.</p>
          </div>
          <div className="space-y-4">
            <a href={`mailto:${s.email}`} className="flex items-center gap-4 group p-5 border border-white/10 hover:border-[#D4AF37] transition" data-testid="contact-email">
              <Mail className="text-[#D4AF37]" /> <span>{s.email}</span>
            </a>
            <a href={`tel:${s.phone.replace(/\s/g,'')}`} className="flex items-center gap-4 group p-5 border border-white/10 hover:border-[#D4AF37] transition" data-testid="contact-phone">
              <Phone className="text-[#D4AF37]" /> <span>{s.phone}</span>
            </a>
            {s.whatsapp && <a href={`https://wa.me/${s.whatsapp}`} target="_blank" rel="noreferrer" className="flex items-center gap-4 p-5 border border-white/10 hover:border-[#D4AF37] transition" data-testid="contact-whatsapp">
              <MessageCircle className="text-[#D4AF37]" /> <span>WhatsApp Us</span>
            </a>}
          </div>
          <div className="flex gap-3 pt-2">
            {s.instagram && <a href={s.instagram} target="_blank" rel="noreferrer" className="h-12 w-12 border border-white/15 hover:border-[#D4AF37] hover:text-[#D4AF37] flex items-center justify-center transition"><Instagram size={18}/></a>}
            {s.youtube && <a href={s.youtube} target="_blank" rel="noreferrer" className="h-12 w-12 border border-white/15 hover:border-[#D4AF37] hover:text-[#D4AF37] flex items-center justify-center transition"><Youtube size={18}/></a>}
            {s.facebook && <a href={s.facebook} target="_blank" rel="noreferrer" className="h-12 w-12 border border-white/15 hover:border-[#D4AF37] hover:text-[#D4AF37] flex items-center justify-center transition"><Facebook size={18}/></a>}
          </div>
        </div>
      </section>

      <AvailabilityForm />
    </div>
  );
}
